import { clsx } from 'clsx'
import { type FC } from 'react'

import { Card, type CardProps } from '@/components'
import { shadowStyles } from '@/lib'

export interface ContainedCardProps extends CardProps {
  withShadow?: boolean
}

export const ContainedCard: FC<ContainedCardProps> = ({ children, className, style, withShadow = true, ...props }) => (
  <Card
    className={clsx('w-full max-w-md gap-2 self-center overflow-hidden rounded-xl bg-white p-2', className)}
    style={[withShadow ? shadowStyles.blackSoft : undefined, style]}
    variant='ghost'
    {...props}
  >
    {children}
  </Card>
)
